/**
 * Kratome — 18+ age verification gate
 * Blocks the storefront behind a full-screen confirmation on first visit.
 * Stores confirmation in localStorage for 24 hours so returning visitors
 * within that window are not asked again. No cookies, no server calls.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "kratome_age_verified";
  var TTL_MS = 24 * 60 * 60 * 1000;
  var gate = document.querySelector("[data-age-gate]");
  if (!gate) return;

  function isVerified() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      return data && data.expires > Date.now();
    } catch (e) {
      return false;
    }
  }

  function setVerified() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ expires: Date.now() + TTL_MS }));
    } catch (e) {}
  }

  if (isVerified()) {
    gate.parentNode.removeChild(gate);
    document.body.style.overflow = "";
    return;
  }

  gate.dataset.open = "true";
  document.body.style.overflow = "hidden";

  var confirmBtn = gate.querySelector("[data-age-gate-confirm]");
  if (confirmBtn) {
    confirmBtn.addEventListener("click", function () {
      setVerified();
      gate.dataset.open = "false";
      document.body.style.overflow = "";
      window.setTimeout(function () {
        if (gate.parentNode) gate.parentNode.removeChild(gate);
      }, 400);
    });
  }
})();
